import React from "react";

const Titles = (props) => (
	<div style={{height:'100%',display:"flex",flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
		<div>
			<h1 className="title-container__title">{!props.city ? "Weather App" : `${props.city}`}</h1>
			<h3 className="title-container__country">{!props.city ? "" : `${props.countryName}`}</h3>			
		</div>
		<a href="#" class="scroll-down" address="true"></a>
		{!props.city ? 
			<h3 className="title-container__subtitle">Current temperature, weather conditions and more...</h3>
			:
			<div>
				<h3 className="title-container__temp">{props.temperature.toFixed(1)} ºC</h3>
				<i className={`wi ${props.weatherIcon} display-1 weatherIcon`}/>
			</div>
		}
	</div>
);

export default Titles;